import { ErrorAlert } from "components/atoms/Alert"
import { Spin } from "components/atoms/Spin"
import { RecruitListView } from "components/molecules/RecruitListView"
import { useInitializeAccountData } from "hooks/useInitializeAccountData"
import { useAsyncLoading } from "hooks/useLoading"
import { useOnBoardingSignIn } from "hooks/useOnBoarding"
import React, { useState, useEffect } from "react"

export const IndexPage = () => {
  const [error, setError] = useState("")
  const [loading, asyncLoading] = useAsyncLoading("index")
  const initialize = useInitializeAccountData()
  const onBoarding = useOnBoardingSignIn()

  useEffect(() => {
    asyncLoading(
      initialize()
        .then(() => {
          onBoarding()
        })
        .catch((e) => {
          setError(e.message)
        }),
    ).catch((e: any) => console.warn(e))
  }, [])

  return loading ? (
    <Spin />
  ) : (
    <RecruitListView>
      {!loading && error && <ErrorAlert>{error}</ErrorAlert>}
    </RecruitListView>
  )
}
